import { useState, useEffect } from "react";
import { apiGet, apiSend, errorMessage } from "./api";
import "./CreateUserModal.css";

function EditUserModal({ userToEdit, onClose, onUpdated }) {
  const [orgs, setOrgs] = useState([]);
  const [form, setForm] = useState({
    email: userToEdit.email,
    name: userToEdit.name,
    surname: userToEdit.surname,
    phone: userToEdit.phone || "",
    password: "",
    right_id:
      userToEdit.role === "Admin" ? 1 :
      userToEdit.role === "Sale" ? 3 :
      userToEdit.role === "Staff" ? 4 : 2,
    // Repli sur "active" : un statut inattendu ne doit pas bannir l'utilisateur
    status_id:
      userToEdit.status === "banned" ? 3 :
      userToEdit.status === "disabled" ? 2 :
      userToEdit.status === "pending" ? 4 : 1,
    organization_id: userToEdit.organization_id || "",
    plan: userToEdit.plan || "None",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [siret, setSiret] = useState("");

  useEffect(() => {
    apiGet("/api/organizations").then(setOrgs).catch(() => setOrgs([]));
  }, []);

  // Le SIRET affiché suit l'organisation sélectionnée : préremplissage au
  // chargement de la liste, et rechargement si l'admin change d'organisation.
  useEffect(() => {
    const org = orgs.find((o) => o.id === parseInt(form.organization_id));
    setSiret(org?.siret || "");
  }, [orgs, form.organization_id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const body = {
      email: form.email,
      name: form.name,
      surname: form.surname,
      // Toujours envoyé, y compris vide : c'est ce qui permet d'effacer le numéro
      phone: form.phone.trim(),
      right_id: parseInt(form.right_id),
      status_id: parseInt(form.status_id),
      organization_id: form.organization_id ? parseInt(form.organization_id) : null,
      plan: form.plan,
    };
    if (form.password) {
      body.password = form.password;
    }
    // Enregistré sur l'organisation sélectionnée, pas sur le compte
    if (form.organization_id && siret.trim()) {
      body.siret = siret.trim();
    }

    try {
      await apiSend(`/api/users/${userToEdit.id}`, "PUT", body, "Erreur lors de la modification");
      onUpdated();
      return;
    } catch (e) {
      setError(errorMessage(e, "Erreur lors de la modification"));
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Modifier l'utilisateur</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}
          <label>Nom</label>
          <input name="name" value={form.name} onChange={handleChange} required />
          <label>Prénom</label>
          <input name="surname" value={form.surname} onChange={handleChange} required />
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} required />
          <label>Téléphone (facultatif)</label>
          <input name="phone" type="tel" value={form.phone} onChange={handleChange} maxLength={20} placeholder="06 12 34 56 78" />
          <label>Mot de passe (laisser vide pour ne pas changer)</label>
          <input name="password" type="password" value={form.password} onChange={handleChange} placeholder="••••••••" />
          <label>Organisation</label>
          <select name="organization_id" value={form.organization_id} onChange={handleChange}>
            <option value="">Aucune</option>
            {orgs.map((o) => (
              <option key={o.id} value={o.id}>{o.name}</option>
            ))}
          </select>
          {form.organization_id && (
            <>
              <label>SIRET du commerce</label>
              <input
                value={siret}
                onChange={(e) => setSiret(e.target.value)}
                inputMode="numeric"
                placeholder="123 456 789 00012"
                maxLength={20}
              />
              <p className="modal-hint">
                14 chiffres — enregistré sur l'organisation sélectionnée et
                repris sur ses factures.
              </p>
            </>
          )}
          <label>Rôle</label>
          <select name="right_id" value={form.right_id} onChange={handleChange}>
            <option value={1}>Admin</option>
            <option value={2}>User</option>
            <option value={3}>Sale</option>
            <option value={4}>Staff</option>
          </select>
          <label>Statut</label>
          <select name="status_id" value={form.status_id} onChange={handleChange}>
            <option value={1}>Active</option>
            <option value={4}>Pending (en attente de validation)</option>
            <option value={2}>Disabled</option>
            <option value={3}>Banned</option>
          </select>
          <label>Plan</label>
          <select name="plan" value={form.plan} onChange={handleChange}>
            <option value="None">Aucun</option>
            <option value="Default">Default</option>
            <option value="Premium">Premium</option>
            <option value="Extra">Extra</option>
          </select>
          <button type="submit" className="modal-submit" disabled={loading}>
            {loading ? "Modification..." : "Enregistrer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditUserModal;
